import {
  useParams,
  useLocation
} from "react-router-dom";

import {
  useState,
  useEffect,
  useRef
} from "react";

import MCQLayout from "../components/MCQLayout";

const PaidMCQPage = () => {

  const {
    teacherId,
    moduleId,
    count
  } = useParams();

  const location =
    useLocation();

  const queryParams =
    new URLSearchParams(
      location.search
    );

  const isReviewMode =
    queryParams.get("review") === "true";

  let selectedType =
    queryParams.get("type") ||
    "model_papers";

  if (selectedType === "model") {
    selectedType = "model_papers";
  }

  if (selectedType === "past") {
    selectedType = "past_papers";
  }

  const limit =
    Number(count) || 25;

  const [questions, setQuestions] =
    useState([]);

  const [answers, setAnswers] =
    useState({});

  const [submitted, setSubmitted] =
    useState(false);

  const [score, setScore] =
    useState(null);

  const [subjectId, setSubjectId] =
    useState(null);

  const [mcqType] =
    useState(selectedType);

  const [showReview, setShowReview] =
    useState(false);

  const [
    historyReviewMode,
    setHistoryReviewMode
  ] = useState(false);

  const [subjectName, setSubjectName] =
    useState("-");

  const [teacherName, setTeacherName] =
    useState("-");

  const EXAM_TIME =
    limit * 60;

  const [timeLeft, setTimeLeft] =
    useState(EXAM_TIME);

  const timerRef =
    useRef(null);

  /* ================= NAVBAR ================= */

  useEffect(() => {

    const navbar =
      document.querySelector(".navbar");

    const handleScroll = () => {

      const currentScroll =
        window.pageYOffset;

      if (!navbar) return;

      if (currentScroll <= 10) {

        navbar.style.transform =
          "translateX(-50%) translateY(0)";

        navbar.style.opacity =
          "1";

      }

      else {

        navbar.style.transform =
          "translateX(-50%) translateY(-130%)";

        navbar.style.opacity =
          "0";

      }

    };

    if (navbar) {

      navbar.style.position =
        "fixed";

      navbar.style.top =
        "15px";

      navbar.style.left =
        "50%";

      navbar.style.width =
        "90%";

      navbar.style.maxWidth =
        "1100px";

      navbar.style.transform =
        "translateX(-50%)";

      navbar.style.zIndex =
        "9999";

      navbar.style.transition =
        "all 0.35s ease";

    }

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () => {

      window.removeEventListener(
        "scroll",
        handleScroll
      );

      if (navbar) {

        navbar.style.transform =
          "translateX(-50%) translateY(0)";

        navbar.style.opacity =
          "1";

      }

    };

  }, []);

  /* ================= FETCH ================= */

  useEffect(() => {

    if (
      !limit ||
      !moduleId ||
      !teacherId
    ) {

      console.log(
        "PARAMS MISSING ❌"
      );

      return;

    }

    fetch(
      `https://edunet.kmechengineering.com/root-engine1/api/mcq-paid?teacher_id=${teacherId}&module_id=${moduleId}&limit=${limit}&mcq_type=${mcqType}`
    )

      .then(res => res.json())

      .then(data => {

        console.log(
          "API DATA ✅",
          data
        );

        setSubjectId(
          Number(
            data.subject_id
          ) || 0
        );

        setSubjectName(
          data.subject_name ||
          "-"
        );

        setTeacherName(
          data.teacher_name ||
          "-"
        );

        const reviewHistoryData =
          JSON.parse(
            localStorage.getItem(
              "review_mcq_data"
            )
          );

        let filteredData =
          data.mcq_data || [];

        /* ================= REVIEW FILTER ================= */

        if (
          isReviewMode &&
          reviewHistoryData
        ) {

          const answerIds =
            Object.keys(
              reviewHistoryData.answers || {}
            ).map(Number);

          filteredData =
            filteredData.filter(q =>
              answerIds.includes(q.id)
            );

        }

        /* ================= FORMAT ================= */

        const formatted =
          filteredData.map(q => ({

            id: q.id,

            question:
              q.question,

            explanation:
              q.explanation,

            options: [

              q.option_a,

              q.option_b,

              q.option_c,

              q.option_d

            ],

            correct_answer:
              String(q.correct_answer)
                .trim()
                .toUpperCase()

          }));

        console.log(
          "FORMATTED QUESTIONS ✅",
          formatted
        );

        setQuestions(
          [...formatted]
        );

        /* ================= REVIEW MODE ================= */

        if (
          isReviewMode &&
          reviewHistoryData
        ) {

          const restoredAnswers = {};

          formatted.forEach(q => {

            restoredAnswers[q.id] =
              reviewHistoryData.answers?.[q.id] || "";

          });

          setAnswers(restoredAnswers);

          setHistoryReviewMode(true);

          setSubmitted(false);

          setShowReview(false);

          setScore(
            reviewHistoryData.marks || 0
          );

        }

        else {

          setAnswers({});

          setSubmitted(false);

          setScore(null);

          setShowReview(false);

        }

        setTimeLeft(
          EXAM_TIME
        );

      })

      .catch(err => {

        console.log(
          "Fetch error ❌",
          err
        );

      });

  }, [
    limit,
    teacherId,
    moduleId,
    mcqType,
    isReviewMode
  ]);

  /* ================= TIMER ================= */

  useEffect(() => {

    if (
      submitted ||
      showReview ||
      historyReviewMode
    ) return;

    timerRef.current =
      setInterval(() => {

        setTimeLeft(t => {

          if (t <= 1) {

            clearInterval(
              timerRef.current
            );

            handleSubmit();

            return 0;

          }

          return t - 1;

        });

      }, 1000);

    return () =>
      clearInterval(
        timerRef.current
      );

  }, [
    submitted,
    showReview,
    historyReviewMode
  ]);

  /* ================= RETRY ================= */

  const handleRetry = () => {

    if (
      historyReviewMode
    )
      return;

    setSubmitted(false);

    setAnswers({});

    setScore(0);

    setShowReview(false);

    setTimeLeft(
      EXAM_TIME
    );

    window.scrollTo({

      top: 0,

      behavior: "smooth"

    });

  };

  /* ================= SUBMIT ================= */

  const handleSubmit = async () => {

    if (
      submitted ||
      historyReviewMode
    )
      return;

    if (timerRef.current) {

      clearInterval(
        timerRef.current
      );

    }

    let total = 0;

    questions.forEach(q => {

      if (
        answers[q.id] ===
        q.correct_answer
      ) {

        total++;

      }

    });

    const user =
      JSON.parse(
        localStorage.getItem(
          "user"
        ) || "null"
      );

    try {

      await fetch(

        "https://edunet.kmechengineering.com/root-engine1/api/mcq-save",

        {

          method: "POST",

          headers: {

            "Content-Type":
              "application/json"

          },

          body: JSON.stringify({

            user_id:
              user?.id,

            subject_id:
              subjectId,

            module_id:
              moduleId,

            teacher_id:
              teacherId,

            mcq_type:
              mcqType,

            marks:
              total,

            total_marks:
              questions.length,

            answers:
              answers,

            type: "paid"

          })

        }

      );

    }

    catch (err) {

      console.log(
        "Save error ❌",
        err
      );

    }

    setScore(total);

    setSubmitted(true);

  };

  return (

    <div>

      <MCQLayout

        title={`Paid ${mcqType.toUpperCase()} MCQ (${questions.length})`}

        subject={
          subjectName
        }

        teacher={
          teacherName
        }

        questions={
          questions
        }

        timeLeft={
          timeLeft
        }

        answers={
          answers
        }

        submitted={
          submitted
        }

        historyReviewMode={
          historyReviewMode
        }

        showReview={
          showReview
        }

        score={score}

        showContinue={
          false
        }

        onAnswer={(
          id,
          opt
        ) =>

          setAnswers(
            prev => ({

              ...prev,

              [id]: opt

            })
          )

        }

        onSubmit={
          handleSubmit
        }

        onRetry={
          handleRetry
        }

        onContinue={() => {

          setShowReview(
            true
          );

        }}

        onReview={() => {

          setSubmitted(
            false
          );

          setShowReview(
            true
          );

        }}

      />

    </div>

  );

};

export default PaidMCQPage;